import { Domain } from "core/types/domain.types";
import { Url } from "core/types/url.types";
import { transformDomain } from "../domain/domain.helpers";

export const transformUrl = (data: any): Url => ({
  id: data?.id,
  // Union presa da Url e non riscritta a mano: con la 026 il backend manda anche
  // 'deindexed', e un cast che elenca i vecchi tre stati sarebbe una dichiarazione falsa
  // (il valore passa comunque, ma il tipo direbbe che non puo' esistere).
  status: data?.status as Url["status"],
  url: data?.url,
  domain: transformDomain(data?.domain),
});
